import { FC } from "react";
import { IconPropsType } from ".";

export const Clock: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "10"}
      height={props.size ?? "10"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="4.5" stroke={props.color} />
      <path d="M6 2L5 5L3 6" stroke={props.color} />
    </svg>
  );
};
